<template>
    <div class="dead-hall" :class="`team-${teamName}`">
        <h3 class="hall-title"> {{hallTitle}} </h3>
        <hr class="hr-separator">
        <ul>
            <li class="dead-hall-cell" v-for="item in hallDisplayList" :key="item">
                <div class="avatar" :style="{backgroundImage: `url(${item.avatar})`}"> </div>
                <p> {{ item.text }} </p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        teamName: {
            type: String,
            required: true,
            validator(value) {
                return ["red", "blue"].includes(value);
            }
        },
        losts: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            hallTitle: "Hall Of The Dead",
            hallDisplayList: [],
        };
    },
    methods: {
        updateDeadHall(){
            this.hallDisplayList = [];
            for(let lost of this.losts){
                let obj = {text: '', avatar: null};
                obj.text = lost.unit.name + (lost.count > 1 ? ` (x${lost.count})` : ''); 
                let images = require.context('../../../public/images/units/', false, /\.png$/);  
                obj.avatar = images(`./${lost.unit.id}.png`);
                this.hallDisplayList.push(obj);
            }
        },
    },
    mounted() {
        this.updateDeadHall();
    },
    watch: {
        losts(){
            this.updateDeadHall();
        },
    }
}
</script>

<style scoped>
.team-red{
    background-color: #a20a0a;
}
.team-blue{
    background-color: #007965;
}
.dead-hall{
    box-sizing: border-box;
    min-width: 270px;
    width: 270px;
    max-height: 835px;
    margin-top: 5px;
    margin-left: 8px;
    margin-right: 8px;
    border: 2px solid rgba(0, 0, 0, 0.527);
    border-radius: 5px;
    opacity: 0.95;
    transition: all 0.32s;
    overflow-y: auto;
}
.dead-hall:hover{
    opacity: 1;
    width: 280px;
    margin-left: 3px;
    margin-right: 3px;
}
.dead-hall:hover > .hr-separator{
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 20px;
}
.hall-title{
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 8px;
    color: white;
    font-size: 1.5em;
}
.dead-hall-cell{
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.301);
    box-shadow: 0px 0px 1px 1px var(--color-darker);
    width: 100%;
    height: 54px;
    margin-left: -10%;
    display: flex;
    margin-bottom: 14px;
    color: white;
    font-size: 1.25em;
    transition: background-color 0.3s, font-size 0.2s;
}
.dead-hall-cell:hover{
    background-color: rgba(0, 0, 0, 0.38);
    font-size: 1.27em;
}
.dead-hall-cell p{
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 13%;
}
.avatar{
    margin: 3%;
    width: 40px;
    height: 40px;
    background-size: cover;
    user-select: none;
    border-radius: 3px;
}
</style>